module.exports = __webpack_public_path__ + "img/logo.0eea23a2.png";